import localPersist from './_localPersist'

export default localPersist({
  key: 'info',
  module: 'info',
  filter: 'setInfo'
})
